<template>
  <div class="avue-logo" :class="{ 'avue-logo--collapse': keyCollapse }">
    <transition name="fade" mode="out-in">
      <brand-logo
        v-if="keyCollapse"
        key="compact"
        :compact="true"
        context="sidebar"
        :show-subtitle="false"
      />
      <brand-logo
        v-else
        key="full"
        context="sidebar"
        :show-subtitle="false"
        subtitle="SFA SALES AUTOMATION"
      />
    </transition>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import BrandLogo from "@/components/brand/BrandLogo";
export default {
  name: "logo",
  components: {
    BrandLogo,
  },
  data() {
    return {};
  },
  created() {},
  computed: {
    ...mapGetters(["keyCollapse"]),
  },
  methods: {},
};
</script>

<style lang="scss">
.fade-leave-active {
  transition: opacity 0.2s;
}
.fade-enter-active {
  transition: opacity 2.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.avue-logo {
  position: fixed;
  top: 0;
  left: 0;
  width: 240px;
  height: 102px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 18px;
  background: linear-gradient(135deg, #0d1e3f 0%, #12346a 45%, #184d98 100%);
  font-size: 20px;
  overflow: hidden;
  box-sizing: border-box;
  box-shadow: 0 8px 24px rgba(6, 26, 71, 0.24);
  color: rgba(255, 255, 255, 0.8);
  z-index: 1024;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);

  .brand-logo {
    width: 100%;
    max-width: 100%;
    justify-content: center;
    line-height: 1;
  }
}

.avue-logo--collapse {
  justify-content: center;
  padding: 0;
}
</style>
